/**
 * Licensed Materials - Property of IBM
* IBM Watson Analytics (C) Copyright IBM Corp. 2017, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'text!../utils/templates/Dragger.html',
	'jquery'
], function (View, DraggerTemplate, $) {
	return class  Dragger extends View {

		constructor (...args) {
			super(...args);

			const options = args[0];
			this.prevSelector = options.prevSelector;
			this.nextSelector = options.nextSelector;
			this.parent = options.parent;
			this.$parent = options.parent.$el;
			this.$el = $(DraggerTemplate);
			this.minPercent = options.minPercent;
			$(this.$el).addClass('draggable');

			this.render();
		}

		render () {
			// Create binded Fn so we can reference them later for clean up with $ off.
			this._onMouseDownHandler = this.onMouseDownHandler.bind(this);

			this.$parent.append(this.$el);
			this.$el.on('mousedown', this._onMouseDownHandler);
			this.$el.on('touchstart', this._onMouseDownHandler);
		}

		onMouseDownHandler (e) {
			if(!this.$prev || !this.$next){
				this.$prev = this.parent.$(this.prevSelector);
				this.$next = this.parent.$(this.nextSelector);
			}

			this.$prev.css('transition', 'none');
			this.$next.css('transition', 'none');

			this.registerEventHandlers();

			e.preventDefault();
		}

		onMouseMoveHandler (e) {
			this.$prev
				.removeClass('filterDockCollapsed filterDockExpanded')
				.addClass('d-dragged');
			this.$next
				.removeClass('filterDockCollapsed filterDockExpanded')
				.addClass('d-dragged');
			this.$el.addClass('d-dragging');

			var totalWidth = this.$prev.outerWidth() + this.$next.outerWidth();
			var _prevWidth = e.pageX - this.$prev.offset().left;

			//Account for 10px margin on the left of the dragger
			_prevWidth = _prevWidth - 10;

			var _draggerWidth  = this.$el.width() / 2;

			var leftPercentage = (_prevWidth - _draggerWidth) / totalWidth;
			var rightPercentage = 1 - leftPercentage;
			var applyCss = true;

			if(leftPercentage * 100 < this.minPercent) {
				this.$prev.attr('style', null);
				this.$next.attr('style', null);

				this.$prev.addClass('filterDockCollapsed');
				this.$next.addClass('filterDockExpanded');
				applyCss = false;
			}

			if(rightPercentage * 100 < this.minPercent) {
				this.$prev.attr('style', null);
				this.$next.attr('style', null);

				this.$prev.addClass('filterDockExpanded');
				this.$next.addClass('filterDockCollapsed');
				applyCss = false;
			}

			this.parent.trigger('resize');

			if(applyCss) {
				this.$prev.css('flex-grow', leftPercentage.toString());
				this.$next.css('flex-grow', rightPercentage.toString());
			}

			e.preventDefault();
		}

		onMouseUp () {
			this.$el.removeClass('d-dragging');

			this.$prev.css('transition', '');
			this.$next.css('transition', '');

			this.deregisterEventHandlers();
		}

		registerEventHandlers () {
			var body = $('body');

			if(this._onMouseMoveHandler) {
				body.off('mousemove', this._onMouseMoveHandler);
				body.off('touchmove', this._onMouseMoveHandler);
			}

			this._onMouseMoveHandler = this.onMouseMoveHandler.bind(this);
			this._onMouseUp = this.onMouseUp.bind(this);

			body
				.on('mousemove', this._onMouseMoveHandler)
				.on('touchmove', this._onMouseMoveHandler)
				.on('mouseup', this._onMouseUp)
				.on('touchend', this._onMouseUp);
		}

		deregisterEventHandlers () {
			$('body')
				.off('mousemove', this._onMouseMoveHandler)
				.off('touchmove', this._onMouseMoveHandler)
				.off('mouseup', this._onMouseUp)
				.off('touchend', this._onMouseUp);

			this._onMouseMoveHandler = null;
			this._onMouseUp = null;
		}

		remove () {
			this.deregisterEventHandlers();
			this.$prev = null;
			this.$next = null;
			this.parent = null;
			this.$parent = null;
			super.remove();
		}
	};
});
